import {
  getUserInfoByOpenid,
  getUserPreferences,
  getRedirectUrl,
  getRedirectSnsapiUrl,
  getOpenidByCode,
  getUserInfoByCodeSnsapi,
  getUserBasicInfo,
  getStoreUserPerm,
  getUser
} from '@/api/user'
import { getCookie, setCookie } from '@/static/js/zjs.js'
import { getPlatform, removeURLParameter } from '../../static/js/zjs'
// import { saveEdition } from '../../api/version'
import { getEdition, saveEdition } from '../../api/setting'
import { getParentLockState, modifyClassGrade, saveUserPref, getBuyBooks } from '../../api/user'

const { NODE_ENV, VUE_APP_openid } = process.env
const isDev = NODE_ENV === 'development'
const WECHAT_NICK_NAME = !isDev ? getCookie('nickname') : '开发昵称'
const WECHAT_HEAD_IMG_URL = !isDev ? getCookie('headimgurl') : 'no'

var OPENID = !isDev || !VUE_APP_openid ? getCookie('openid') : ''
if (location.hostname === 'localhost' || /^[\d.]+$/.test(location.hostname)) {
  // const test = 'ost3Is7YZdccI1LtewUTW6qvM1MY'
  // OPENID = getCookie('openid')
  // OPENID = 'ost3Is0EqskJaV0dvCdGG3QoDLNk'
  // OPENID = 'ost3Is7YZdccI1LtewUTW6qvM1MY'
  OPENID = 'ost3Is41DSGqhszbNcumO3ACgzXI'
  // OPENID = 'dfjkadsjfksj'
  // OPENID = getCookie('openid') || 'ost3Is81eJ4l27mr16Kljfrgo8uk'
  console.log(
    '---------------------------------ost3Is81eJ4l27mr16Kljfrgo8uk---------------------------',
    OPENID
  )
}
// if (navigator.platform.indexOf("Win") > -1 && u.env.rt != 'wx') {
//   OPENID = getCookie('openid') || 'ost3Is0EqskJaV0dvCdGG3QoDLNk'
// }

export default {
  namespaced: true,
  state: {
    unreadMessages: 0, // 用户未读消息数量
    appid: getPlatform().appid,
    platform: getPlatform().platform,
    openid: OPENID,
    userInfo: '',
    userPref: '',
    storeUserPermState: '', // 机构用户状态。1是，0否
    parentLockState: '', // 家长锁开关状态。1是，0否
    RedNum: '', // 红包碎片个数
    RedMoney: '', // 奖学金金额
    settingBookVersion: [],
    SvipVersion: {}, // Svip选择的版本
    buyBooks: [],
    wechatUserInfo: {
      nickname: WECHAT_NICK_NAME,
      headimgurl: WECHAT_HEAD_IMG_URL
    },
    subscribe: false, // 是否关注了平台
    haveBeenSetGrade: false // 是否新用户
  },
  // mutations 修改器，用于修改state中的定义的状态变量,同步
  mutations: {
    setUnreadMessages(state, unreadMessages) {
      state.unreadMessages = unreadMessages
    },
    setOpenid(state, payload) {
      state.openid = payload
      setCookie('openid', payload)
    },
    setWechatUserInfo(state, payload) {
      for (const key in payload) {
        if (payload[key]) {
          state.wechatUserInfo[key] = payload[key]
          setCookie(key, payload[key])
        }
      }
    },
    setUserInfo(state, payload) {
      state.haveBeenSetGrade = typeof payload.wbGrade === 'string'
      state.userInfo = payload
      setCookie('userinfo', encodeURIComponent(JSON.stringify(payload)))
    },
    setUserPref(state, payload) {
      console.log('user pref', payload)
      state.userPref = payload
    },
    setRedNum(state, payload) {
      state.RedNum = payload
    },
    setRedMoney(state, payload) {
      state.RedMoney = payload
    },
    SET_SETTINGBOOKVERSION(state, dictionaryList) {
      state.settingBookVersion = dictionaryList
    },
    setStoreUserPermState(state, payload) {
      state.storeUserPermState = payload
    },
    setParentLockState(state, payload) {
      state.parentLockState = payload
    },
    setBuyBooks(state, payload) {
      state.buyBooks = payload
    },
    UPDATE_USER_MOBILE_NUMBER(state, phoneNumber) {
      state.userInfo.mobile = `${phoneNumber}`
    },
    SET_SUBSCRIBE(state, bool) {
      state.subscribe = bool
    }
  },
  // 存放异步操作，由 action 去触发 mutation
  actions: {
    async updateUserInfo({ state, commit }, paload) {
      if (paload) {
        commit('setUserInfo', paload)
        return paload
      }
      if (state.openid) {
        const res = await getUserInfoByOpenid({ openid: state.openid })
        const data = res.data
        // data['vipPeriodEnd'] = 'Aug 26, 2020 8:13:50 AM'
        commit('setUserInfo', data)
        return data
      }
    },
    async updateUserPref({ state, commit }, paload) {
      if (paload) {
        commit('setUserPref', paload)
        return paload
      }
      if (state.openid) {
        const res = await getUserPreferences({ openid: state.openid })
        commit('setUserPref', res.data)
        return res.data
      }
    },
    async updateBasicInfo({ state, commit }) {
      const ret = await getUserBasicInfo({
        openid: state.openid
      }).then(({ data }) => data)
      return ret
    },
    // 更新班级、年级 - 首页
    async modifyClassGrade(
      { state, commit, rootGetters, dispatch },
      { grade, term, wbVersion, clearVersion }
    ) {
      const res = await modifyClassGrade({
        openid: state.openid,
        userPrefString: `grade${grade}${term}:${wbVersion}`,
        clearVersion
      })
      if (res.data && res.data.openid) {
        if (clearVersion === 1) {
          commit('SET_SETTINGBOOKVERSION', [])
        }
        if (window.Statistic) {
          window.Statistic.changeGrade({
            app: 'shanxiCms',
            grade: `${grade}${term}`, // 年级加学期
            openid: state.openid,
            vip: 'sv'
          })
        }
        await dispatch('dictionary/getCouresVersionListFromJSON', grade, { root: true })
        commit('setUserPref', res.data)
        commit('informationFlow/CLEAN', null, {
          root: true
        })
        return res.data
      }
    },
    async modifySettingVersion({ state, commit, dispatch }, list) {
      const res = await saveEdition(
        {
          openid: state.openid
        },
        list
      )
      await dispatch('updateTextBookVersion')
      return res.data
    },
    // 获取用户当前选择的教材版本-首页
    async updateTextBookVersion({ state, commit, dispatch, rootGetters }) {
      const res = await getEdition({
        openid: state.openid
      })
      await dispatch('dictionary/getCouresVersionListFromJSON', rootGetters.userGrade, {
        root: true
      })
      commit('SET_SETTINGBOOKVERSION', res.all)
      return res
    },
    /**
     * 获取用户的微信openid
     * @param {*} param0 store
     * @param {*} param1 微信链接包含的字段
     */
    async getOpenid({ state, commit }, { code, appid, isSnsapiIserinfo }) {
      const ret = {
        openid: null,
        url: null,
        appid
      }
      const { openid, wechatUserInfo } = state
      const { nickname, headimgurl } = wechatUserInfo
      if (isSnsapiIserinfo && (!openid || !nickname || !headimgurl)) {
        // 非静默授权
        if (!code) {
          ret.url = await getRedirectSnsapiUrl().then(({ data }) => data)
        } else {
          const { openid, nickname, headimgurl } = await getUserInfoByCodeSnsapi({ code }).then(
            (res) => {
              console.warn('微信授权后拿到的个人信息', res)
              return res.data
            }
          )
          ret.openid = openid
          ret.nickname = nickname
          ret.headimgurl = headimgurl
          if (!ret.openid) ret.url = removeURLParameter(window.location.href, 'code')
        }
        if (ret.openid) {
          commit('setOpenid', ret.openid)
          commit('setWechatUserInfo', {
            headimgurl: ret.headimgurl,
            nickname: ret.nickname
          })
        } else {
          appid && setCookie('appid', appid)
        }
        return ret
      } else {
        // 静默授权
        if (!openid) {
          if (!code) {
            ret.url = await getRedirectUrl().then(({ data }) => data)
          } else {
            ret.openid = await getOpenidByCode({ code }).then(({ data }) => data)
            if (!ret.openid) ret.url = removeURLParameter(window.location.href, 'code')
          }
        } else {
          ret.openid = openid
        }
        if (ret.openid) {
          commit('setOpenid', ret.openid)
        } else {
          appid && setCookie('appid', appid)
        }
        return ret
      }
    },
    // 获取机构用户状态
    async ACTION_getStoreUserPermState({ state, commit }) {
      const { openid, storeUserPermState } = state
      if (storeUserPermState !== '') {
        return storeUserPermState
      }
      const res = await getStoreUserPerm({ openid })
      let status = false
      if (String(res.data.data) === '1') {
        status = true
      }
      commit('setStoreUserPermState', status)
      return status
    },
    // 获取家长锁状态
    async ACTION_getParentLockState({ state, commit }) {
      const { openid, parentLockState } = state
      if (parentLockState !== '') {
        return parentLockState
      }
      const res = await getParentLockState({ openid })
      let status = false
      if (String(res.data) === '1') {
        status = true
      }
      commit('setParentLockState', status)
      return status
    },
    // 保存userPref
    async saveUserPreferences({ state, dispatch }, { userPref }) {
      const { openid } = state
      const res = await saveUserPref({
        openid,
        userPref
      })
      const ret = await dispatch('updateUserPref', res.data)
      return ret
    },
    // 获取用户购买的书籍
    async getUserBuyBooks({ state, commit }) {
      const { openid } = state
      const res = await getBuyBooks({ openid })
      commit('setBuyBooks', res.data.data)
      return res.data.data
    },
    // 用户是否关注了平台
    async requestUserInfoOfWechat({ state, commit }) {
      const { openid } = state
      const { status, data, msg } = await getUser({ openid })

      if (status === 200) {
        const { subscribe } = data
        commit('SET_SUBSCRIBE', subscribe === 1)
      }
      return { status, data, msg }
    }
  }
}
